import { render, staticRenderFns } from "./SectionComment.vue?vue&type=template&id=394116fa"
import script from "./SectionComment.vue?vue&type=script&lang=ts"
export * from "./SectionComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports